import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { Pill } from '@feathr/components';
import { useStore } from '@feathr/extender/state';

import * as styles from './Tags.css';

interface IProps {
  className?: string;
  value: string[];
}

function Tags({ className, value }: IProps): JSX.Element {
  const { Tags: TagsCollection } = useStore();
  return (
    <div className={classNames(styles.root, className)}>
      {value.map((tagId: string) => {
        const tag = TagsCollection.get(tagId);
        return (
          <Pill key={tagId} theme={'neutral'}>
            {tag.name}
          </Pill>
        );
      })}
    </div>
  );
}

export default observer(Tags);
